import { combineEpics } from 'redux-observable'

export const createEffects = (moduleActions) => {
  return combineEpics()
}
